import React, { useState, useEffect, useRef } from 'react';
import { useParams, useNavigate } from 'react-router-dom';
import { Stack, Button, Box, Chip, Grid, Card, CardContent, CardActions, Paper, CircularProgress, Popover, Typography, Divider, MenuItem } from '@mui/material';
import client from '../common/client';
import AceEditor from "react-ace";
import 'brace/ext/searchbox';
import "ace-builds/src-noconflict/mode-java";
import "ace-builds/src-noconflict/theme-github";
import toast, { Toaster } from 'react-hot-toast';
import HelpIcon from '@mui/icons-material/HelpOutline';


const ProgramCode = props => {
    const navigate = useNavigate();
    const [value, setValue] = useState('');
    const [modified, setModified] = useState(false);
    const [relativeScreenList, setRelativeScreenList] = useState([]);
    const [loading, setLoading] = useState(false);

    useEffect(() => {
        setLoading(true)
        if (props.screen_id) {
            client.request_get('/screen/' + props.screen_id).then(res => {
                if (res.javascript_on_create)
                    setValue(res.javascript_on_create)
                else
                    setValue('')
                // console.log('res.from_screen_list', res.from_screen_list.length)
                // console.log('res.screen_list', res.screen_list.length)
                let new_list = []
                res.from_screen_list.map(m => {
                    if(new_list.includes(m.id) == false && m.id != props.screen_id)
                        new_list.push(m)
                })

                new_list.push({
                    id: res.id,
                    name: res.name,
                    block_list: res.block_list,
                    self: true,
                })
                
                    
                res.screen_list.map(m => {
                    if(new_list.includes(m.id) == false && m.id != props.screen_id)
                        new_list.push(m)
                })
                // console.log('new_list', new_list.length, new_list)
                setRelativeScreenList(new_list)
                setLoading(false)
            })
        }
    }, [props.screen_id])

    function useKey(key, cb) {
        const callback = useRef(cb);

        useEffect(() => {
            callback.current = cb;
        })


        useEffect(() => {
            function handle(event) {
                if (event.code === key) {
                    callback.current(event);
                } else if (key === 'ctrls' && event.key === 's' && (event.ctrlKey || event.metaKey)) {
                    callback.current(event);
                    event.preventDefault();
                    return true
                }
            }

            document.addEventListener('keydown', handle);
            return () => document.removeEventListener("keydown", handle)
        }, [key])
    }

    useKey('ctrls', () => {
        if(loading || !modified)
            return

        toast.promise(
            getSavePromise(),
            {
                loading: 'Saving...',
                success: <b>Saved!</b>,
                error: <b>Could not save.</b>,
            }
        );
    });

    const save = () => {
        if(loading)
            return
        toast.promise(
            getSavePromise(),
            {
                loading: 'Saving...',
                success: <b>Saved!</b>,
                error: <b>Could not save.</b>,
            }
        );
    }

    const getSavePromise = () => {
        return new Promise((resolve, reject) => {
            client.request_post('/api/screen/script/' + props.screen_id, { javascript_on_create: value }).then(res => {
                setModified(false)
                resolve();
            })
        })
    }

    const onClickChip = (m) => {
        navigate(`/ide?screen_id=${m.id}&block_id=${m.block_list[0].block_id}`)
    }

    const onClickJevil = () => {
        window.open('https://document.devil-app-builder.com/#/ko/Alert', '_blank')
    }

    const deleteCode = () => {
        if(loading)
            return

        if (window.confirm('Do you want to remove the screen?')) {
            toast.promise(
                getDeletePromise(),
                {
                    loading: 'Removing...',
                    success: <b>Removed!</b>,
                    error: <b>Could not remove.</b>,
                }
            );
        }
    }

    const getDeletePromise = () => {
        return new Promise((resolve, reject) => {
            client.request_post('/screen/' + props.screen_id).then(res => {
                setModified(false)
                resolve();
            })
        })
    }

    return (
        <Box sx={{ width: '100%', height: '100%' }}>
            <Toaster
                position="bottom-center"
                reverseOrder={false}
            />
            <Box display="flex" sx={{width: '100%', overflow: 'hidden',}} alignItems={"center"} justifyContent={'space-between'} pr={1} pl={1}>
                <Stack direction={"row"} spacing={1} sx={{
                    height: '50px',
                    maxWidth: '40vw',
                    alignItems: 'center',
                    overflow: 'auto',
                }}>
                    {relativeScreenList.map(m => (
                        <Chip key={m.id} label={m.name} color={m.self ? 'primary' : 'default'} onClick={() => onClickChip(m)} />
                    ))}
                </Stack>
                <Box ml={2}>
                    <Button size="small" variant="outlined" onClick={onClickJevil} startIcon={<HelpIcon/>} >Jevil</Button>
                </Box>
            </Box>

            <AceEditor
                onChange={(newValue) => { setValue(newValue); setModified(true) }}
                width={'100%'}
                height={props.height ? props.height : 'calc(100% - 100px)'}
                placeholder={props.label}
                mode="javascript"
                theme="github"
                name="blah2"
                wrapEnabled={true}
                // onChange={newValue=>{handleChange(newValue)}}
                fontSize={14}
                showPrintMargin={true}
                showGutter={true}
                highlightActiveLine={true}
                value={value}
                setOptions={{
                    enableBasicAutocompletion: false,
                    enableLiveAutocompletion: false,
                    enableSnippets: false,
                    showLineNumbers: true,
                    tabSize: 2,
                }} />

            <Box sx={{
                width: '100%',
                height: '50px',
            }}>
                <Divider />
                <Box sx={{
                    width: '100%',
                    height: '100%',
                    display: 'flex',
                    alignItems: 'center',
                    paddingLeft: '10px',
                    paddingRight: '10px',
                    justifyContent: 'space-between',
                }}>
                    <Button variant="contained" disabled={!modified || loading} onClick={save} >Save</Button>
                    <Button variant="outlined" color="warning" disabled={loading} onClick={deleteCode} >Delete</Button>
                </Box>
            </Box>
        </Box>
    );
};

export default ProgramCode;
